import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import Dashboard from '../pages/Dashboard';
import Profile from "../pages/Profile";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import Product from "../pages/Product";
import ProductNew from "../pages/Product/New";
import StockMovement from "../pages/StockMovement";
import StockMovementNew from "../pages/StockMovement/New";
import Sales from "../pages/Sales";
import SalesList from "../pages/SalesList";
import Company from "../pages/Company";
import CompanyNew from "../pages/Company/New";
import Operator from "../pages/Operator";
import OperatorNew from "../pages/Operator/New";
import Route from './Router';

export default function Routes() {
  return (
    <Router>
      <Switch>
        <Route path="/login" exact component={SignIn} />
        <Route path="/register" exact component={SignUp} />
        <Route path="/profile" exact component={Profile} isPrivate />
        <Route path="/dashboard" component={Dashboard} isPrivate />
        <Route path="/product" component={Product} isPrivate exact/>
        <Route path="/product/new" component={ProductNew} isPrivate/>
        <Route path="/product/:id/edit" component={ProductNew} isPrivate />
        <Route path="/stock-movement" component={StockMovement} isPrivate exact/>
        <Route path="/stock-movement/new" component={StockMovementNew} isPrivate/>
        <Route path="/stock-movement/:id/edit" component={StockMovementNew} isPrivate />
        <Route path="/sales" component={Sales} isPrivate exact/>
        <Route path="/sales-list" component={SalesList} isPrivate exact/>
        <Route path="/company" component={Company} isPrivate exact/>
        <Route path="/company/new" component={CompanyNew} isPrivate/>
        <Route path="/company/:id/edit" component={CompanyNew} isPrivate />
        <Route path="/operator/:companyId" component={Operator} isPrivate exact/>
        <Route path="/operator/:companyId/new" component={OperatorNew} isPrivate/>
        <Route path="/operator/:companyId/:id/edit" component={OperatorNew} isPrivate />
        <Route component={Dashboard} isPrivate/>
      </Switch>
    </Router>
  );
}
